<!-- show fail message -->

@if (isLoading()) {
  <!-- show loading message when retrying to fetch status -->
  <ng-container>
    <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
      <ion-row>
        <ion-col>
          <p class="ion-text-center"><ion-spinner></ion-spinner></p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
} @else {
  <ng-container>
    <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
      <ion-row>
        <ion-col>
          @switch (orderState()) {
            @case (OrderState.failed) {
              <h2>{{ 'order_statusFailed' | translate }}</h2>
              <p>{{ 'order_statusFailedIntro' | translate }}</p>
            }
            @case (OrderState.pending) {
              <h2>{{ 'order_statusPending' | translate }}</h2>
              <p>{{ 'order_statusPendingIntro' | translate }}</p>
            }
            @case (OrderState.succeeded) {
              <h2>{{ 'order_statusSucceeded' | translate }}</h2>
              <p>{{ 'order_statusSucceededIntro' | translate }}</p>
            }
            @case (OrderState.error) {
              <h2>{{ 'order_statusError' | translate }}</h2>
              <p>
                {{ 'order_statusErrorIntro' | translate }}<br /><br />
                <ion-button type="button" color="primary" (click)="onReload()">
                  <small>{{ 'order_statusReload' | translate }}</small>
                </ion-button>
              </p>
            }
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
}
